import {
  FormControl,
  InputLabel,
  OutlinedInput,
  Paper,
  TextField,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./editOffer.module.scss";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import { useLocation, useNavigate } from "react-router-dom";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import { createOffer, updateOffer, getAllOffer } from "../../store/actions";

// Mock Data – Replace with API later
const productOptions = [
  { id: "p1", name: "Product A" },
  { id: "p2", name: "Product B" },
  { id: "p3", name: "Product C" },
];

const TopInputBox = [
  {
    id: 1,
    label: "PRODUCT NAME*",
    inputkey: "productId",
    type: "multi-select",
  },
  {
    id: 2,
    label: "CATEGORY NAME",
    inputkey: "categoryId",
    type: "multi-select",
  },
  {
    id: 3,
    label: "STATUS*",
    inputkey: "status",
  },
];

const BottomInputBox = [
  {
    id: 4,
    label: "PERCENTAGE %*",
    inputkey: "percentage",
    type: "number",
  },
  {
    id: 5,
    label: "START DATE*",
    inputkey: "startDate",
    type: "date",
  },
  {
    id: 6,
    label: "END DATE *",
    inputkey: "endDate",
    type: "date",
  },
];

const statusOptions = [
  { label: "1", value: "Active" },
  { label: "0", value: "Inactive" },
];

const initialState = {
  productId: [],
  categoryId: [],
  percentage: "",
  startDate: "",
  endDate: "",
  status: "",
};

const EditOffer = ({ offer = {}, categories = [], products = [] }) => {
  const [offerDetails, setOfferDetails] = useState(initialState);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [originalOffer, setOriginalOffer] = useState(initialState);

  useEffect(() => {
    if (location?.state === "edit" && offer) {
      const mappedOffer = {
        productId: offer?.productId || [],
        categoryId: offer?.categoryId || [],
        percentage: offer?.percentage || "",
        startDate: offer?.startDate || "",
        endDate: offer?.endDate || "",
        status: offer?.status?.toString(),
      };
      setOfferDetails(mappedOffer);
      setOriginalOffer(mappedOffer);
    }
  }, [location?.state, offer]);

  const isEqual = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
  };

  const isFormValid =
    offerDetails?.productId.length &&
    // offerDetails?.categoryId.length &&
    offerDetails?.percentage &&
    offerDetails?.startDate &&
    offerDetails?.endDate &&
    offerDetails?.status;

  const isSubmitDisabled =
    !isFormValid ||
    (location?.state === "edit" && isEqual(offerDetails, originalOffer));

  const onInputChange = (key, value = "") => {
    let newValue = value;

    // Normalize date format to YYYY-MM-DD
    if (key === "startDate" || key === "endDate") {
      try {
        newValue = new Date(value).toISOString().split("T")[0];
      } catch {
        newValue = value;
      }
    }

    setOfferDetails((prev) => ({
      ...prev,
      [key]: newValue,
    }));
  };

  const handleSubmit = () => {
    const payload = {
      productId: offerDetails?.productId,
      categoryId: offerDetails?.categoryId,
      percentage: offerDetails?.percentage,
      startDate: offerDetails?.startDate,
      endDate: offerDetails?.endDate,
      status: offerDetails?.status,
    };

    if (location?.state === "edit") {
      dispatch(
        updateOffer({
          payload: { ...offer, ...payload },
          callback: {
            success: () => {
              // Update offers list without page reload
              dispatch(getAllOffer());
              navigate(-1);
            },
          },
        })
      );
    } else {
      dispatch(
        createOffer({
          payload: payload,
          callback: {
            success: () => {
              dispatch(getAllOffer());
              navigate(-1);
            },
          },
        })
      );
    }
  };

  return (
    <>
      <StatusCard
        leftContent={location?.state === "edit" ? "EDIT OFFER" : "ADD OFFER"}
      />
      <div className={styles.container}>
        <Paper
          elevation={2}
          className={styles.wrapper}
          sx={{ borderRadius: "20px" }}
        >
          <div className={styles.top}>
            <Row className={styles.inputRow}>
              {TopInputBox.map((item) => (
                <Col key={item.id}>
                  <FormControl
                    className={styles.inputContainer}
                    variant="outlined"
                    fullWidth
                  >
                    <InputLabel id={`label-${item.inputkey}`}>
                      {item.label}
                    </InputLabel>
                    <Select
                      sx={{ borderRadius: "12px" }}
                      labelId={`label-${item.inputkey}`}
                      id={`select-${item.inputkey}`}
                      multiple={item.inputkey !== "status"}
                      value={
                        item.inputkey !== "status"
                          ? offerDetails[item.inputkey] || []
                          : offerDetails[item.inputkey] || ""
                      }
                      onChange={(e) =>
                        onInputChange(item.inputkey, e.target.value)
                      }
                      label={item.label}
                      input={<OutlinedInput label={item.label} />}
                      renderValue={(selected) => {
                        if (item.inputkey === "status") {
                          const selectedOption = statusOptions.find(
                            (opt) => opt.label === selected
                          );
                          return selectedOption?.value || "";
                        } else {
                          return selected
                            .map(
                              (id) =>
                                (item.inputkey === "productId"
                                  ? products
                                  : categories
                                ).find((opt) => opt.id === id)?.name
                            )
                            .join(", ");
                        }
                      }}
                    >
                      {(item.inputkey === "productId"
                        ? products
                        : item.inputkey === "categoryId"
                        ? categories
                        : statusOptions
                      ).map((option) => (
                        <MenuItem
                          key={option.id || option.label}
                          value={option.id || option.label}
                        >
                          {item.inputkey !== "status" && (
                            <Checkbox
                              checked={offerDetails[item.inputkey]?.includes?.(
                                option.id
                              )}
                            />
                          )}
                          <ListItemText primary={option.name || option.value} />
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Col>
              ))}
            </Row>
          </div>

          <div className={styles.bottom}>
            <Row className={styles.inputRow}>
              {BottomInputBox.map((item) => (
                <Col key={item.id}>
                  <FormControl className={styles.inputContainer}>
                    <TextField
                      fullWidth
                      id={`outlined-input-${item.inputkey}`}
                      label={item.label}
                      variant="outlined"
                      type={item.type}
                      value={offerDetails[item.inputkey]}
                      onChange={(e) =>
                        onInputChange(item.inputkey, e.target.value)
                      }
                      InputLabelProps={{
                        shrink: true, // ✅ force the label to float for number input
                      }}
                      InputProps={{
                        classes: {
                          root: styles.input,
                          input: styles.inputFeild,
                        },
                      }}
                    />
                  </FormControl>
                </Col>
              ))}
            </Row>
          </div>

          <div className={styles.buttonCotainer}>
            <div className={styles.bottomLeft}></div>
          </div>
        </Paper>

        <div className={styles.bottomRight}>
          <OutlinedButton
            title={"Cancel"}
            txtClr={"hsla(187, 98%, 16%, 1)"}
            border={"1px solid hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            onclick={() => navigate(-1)}
          />
          <CustomButton
            title={"Submit"}
            txtClr={"#FFFFFF"}
            background={isSubmitDisabled ? "grey" : "hsla(187, 98%, 16%, 1)"}
            width={"90px"}
            height={"34px"}
            borderRadius={"12px"}
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    offer: state?.offer?.offer,
    categories: state?.category?.categories,
    products: state?.product?.products,
  };
};

export default connect(mapStateToProps, null)(EditOffer);



// reverted code
// import {
//   FormControl,
//   InputLabel,
//   OutlinedInput,
//   Paper,
//   TextField,
//   Select,
//   MenuItem,
//   Checkbox,
//   ListItemText,
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import { Col, Row } from "react-bootstrap";
// import styles from "./editOffer.module.scss";
// import CustomButton from "../../components/customComponents/customButton/CustomButton";
// import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
// import { useLocation, useNavigate } from "react-router-dom";
// import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
// import { connect, useDispatch } from "react-redux";
// import { createOffer, updateOffer, getAllOffer } from "../../store/actions";

// // Mock Data – Replace with API later
// const productOptions = [
//   { id: "p1", name: "Product A" },
//   { id: "p2", name: "Product B" },
//   { id: "p3", name: "Product C" },
// ];

// const statusOptions = [
//   { label: "1", value: "Active" },
//   { label: "0", value: "Inactive" },
// ];
// const typeOptions = [
//   { label: "1", value: "Products" },
//   { label: "0", value: "Category" },
// ];

// const initialState = {
//   type: null,
//   productId: [],
//   categoryId: [],
//   percentage: "",
//   startDate: "",
//   endDate: "",
//   status: "",
// };

// const EditOffer = ({ offer = {}, categories = [], products = [] }) => {
//   const [offerDetails, setOfferDetails] = useState(initialState);
//   const inputBox = [
//     {
//       id: 1,
//       label: "TYPE *",
//       inputkey: "type",
//     },
//     {
//       id: 2,
//       label: "PRODUCT NAME*",
//       inputkey: "productId",
//       type: "multi-select",
//     },
//     {
//       id: 3,
//       label: "CATEGORY NAME",
//       inputkey: "categoryId",
//       type: "multi-select",
//     },
//     {
//       id: 4,
//       label: "STATUS*",
//       inputkey: "status",
//     },
//   ];

//   const BottomInputBox = [
//     {
//       id: 5,
//       label: "PERCENTAGE %*",
//       inputkey: "percentage",
//       type: "number",
//     },
//     {
//       id: 6,
//       label: "START DATE*",
//       inputkey: "startDate",
//       type: "date",
//     },
//     {
//       id: 7,
//       label: "END DATE *",
//       inputkey: "endDate",
//       type: "date",
//     },
//   ];

//   const [topInputBox, setTopInputBox] = useState(inputBox);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const [originalOffer, setOriginalOffer] = useState(initialState);

//   useEffect(() => {
//     if (location?.state === "edit" && offer) {
//       const mappedOffer = {
//         productId: offer?.productId || [],
//         categoryId: offer?.categoryId || [],
//         percentage: offer?.percentage || "",
//         startDate: offer?.startDate || "",
//         endDate: offer?.endDate || "",
//         status: offer?.status?.toString(),
//       };
//       setOfferDetails(mappedOffer);
//       setOriginalOffer(mappedOffer);
//     }
//   }, [location?.state, offer]);

//   const isEqual = (a, b) => {
//     return JSON.stringify(a) === JSON.stringify(b);
//   };

//   const isFormValid =
//     offerDetails?.productId.length &&
//     // offerDetails?.categoryId.length &&
//     offerDetails?.type &&
//     offerDetails?.percentage &&
//     offerDetails?.startDate &&
//     offerDetails?.endDate &&
//     offerDetails?.status;

//   const isSubmitDisabled =
//     !isFormValid ||
//     (location?.state === "edit" && isEqual(offerDetails, originalOffer));

//   const onInputChange = (key, value = "") => {
//     console.log("key", key);
//     let newValue = value;

//     console.log("newValue", newValue);

//     // Normalize date format to YYYY-MM-DD
//     if (key === "startDate" || key === "endDate") {
//       try {
//         newValue = new Date(value).toISOString().split("T")[0];
//       } catch {
//         newValue = value;
//       }
//     }

//     setOfferDetails((prev) => ({
//       ...prev,
//       [key]: newValue,
//     }));
//   };

//   const handleSubmit = () => {
//     const payload = {
//       productId: offerDetails?.productId,
//       categoryId: offerDetails?.categoryId,
//       percentage: offerDetails?.percentage,
//       startDate: offerDetails?.startDate,
//       endDate: offerDetails?.endDate,
//       status: offerDetails?.status,
//     };

//     if (location?.state === "edit") {
//       dispatch(
//         updateOffer({
//           payload: { ...offer, ...payload },
//           callback: {
//             success: () => {
//               // Update offers list without page reload
//               dispatch(getAllOffer());
//               navigate(-1);
//             },
//           },
//         })
//       );
//     } else {
//       dispatch(
//         createOffer({
//           payload: payload,
//           callback: {
//             success: () => {
//               dispatch(getAllOffer());
//               navigate(-1);
//             },
//           },
//         })
//       );
//     }
//   };

//   useEffect(() => {
//     if (offerDetails?.type === "0") {
//       const input = inputBox?.filter((item) => item?.id !== 2);
//       setTopInputBox(input);
//     } else {
//       const input = inputBox?.filter((item) => item?.id !== 3);
//       setTopInputBox(input);
//     }
//   }, [offerDetails?.type]);

//   return (
//     <>
//       <StatusCard
//         leftContent={location?.state === "edit" ? "EDIT OFFER" : "ADD OFFER"}
//       />
//       <div className={styles.container}>
//         <Paper
//           elevation={2}
//           className={styles.wrapper}
//           sx={{ borderRadius: "20px" }}
//         >
//           <div className={styles.top}>
//             <Row className={styles.inputRow}>
//               {topInputBox.map((item) => (
//                 <Col key={item.id}>
//                   <FormControl
//                     className={styles.inputContainer}
//                     variant="outlined"
//                     fullWidth
//                   >
//                     <InputLabel id={`label-${item.inputkey}`}>
//                       {item.label}
//                     </InputLabel>
//                     <Select
//                       sx={{ borderRadius: "12px" }}
//                       labelId={`label-${item.inputkey}`}
//                       id={`select-${item.inputkey}`}
//                       multiple={
//                         item.inputkey !== "status" && item.inputkey !== "type"
//                       }
//                       disabled={item?.disabled}
//                       value={
//                         item.inputkey !== "status" && item.inputkey !== "type"
//                           ? offerDetails[item.inputkey] || []
//                           : offerDetails[item.inputkey] || ""
//                       }
//                       onChange={(e) =>
//                         onInputChange(item.inputkey, e.target.value)
//                       }
//                       label={item.label}
//                       input={<OutlinedInput label={item.label} />}
//                       renderValue={(selected) => {
//                         if (item.inputkey === "status") {
//                           const selectedOption = statusOptions.find(
//                             (opt) => opt.label === selected
//                           );
//                           return selectedOption?.value || "";
//                         } else if (item.inputkey === "type") {
//                           const selectedOption = typeOptions.find(
//                             (opt) => opt.label === selected
//                           );
//                           return selectedOption?.value || "";
//                         } else {
//                           return selected
//                             .map(
//                               (id) =>
//                                 (item.inputkey === "productId"
//                                   ? products
//                                   : categories
//                                 ).find((opt) => opt.id === id)?.name
//                             )
//                             .join(", ");
//                         }
//                       }}
//                     >
//                       {(item.inputkey === "productId"
//                         ? products
//                         : item.inputkey === "categoryId"
//                         ? categories
//                         : item.inputkey === "type"
//                         ? typeOptions
//                         : statusOptions
//                       ).map((option) => (
//                         <MenuItem
//                           key={option.id || option.label}
//                           value={option.id || option.label}
//                         >
//                           {item.inputkey !== "status" &&
//                             item.inputkey !== "type" && (
//                               <Checkbox
//                                 checked={offerDetails[
//                                   item.inputkey
//                                 ]?.includes?.(option.id)}
//                               />
//                             )}
//                           <ListItemText primary={option.name || option.value} />
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </FormControl>
//                 </Col>
//               ))}
//             </Row>
//           </div>

//           <div className={styles.bottom}>
//             <Row className={styles.inputRow}>
//               {BottomInputBox.map((item) => (
//                 <Col key={item.id}>
//                   <FormControl className={styles.inputContainer}>
//                     <TextField
//                       fullWidth
//                       id={`outlined-input-${item.inputkey}`}
//                       label={item.label}
//                       variant="outlined"
//                       type={item.type}
//                       value={offerDetails[item.inputkey]}
//                       onChange={(e) =>
//                         onInputChange(item.inputkey, e.target.value)
//                       }
//                       InputLabelProps={{
//                         shrink: true, // ✅ force the label to float for number input
//                       }}
//                       InputProps={{
//                         classes: {
//                           root: styles.input,
//                           input: styles.inputFeild,
//                         },
//                       }}
//                     />
//                   </FormControl>
//                 </Col>
//               ))}
//             </Row>
//           </div>

//           <div className={styles.buttonCotainer}>
//             <div className={styles.bottomLeft}></div>
//           </div>
//         </Paper>

//         <div className={styles.bottomRight}>
//           <OutlinedButton
//             title={"Cancel"}
//             txtClr={"hsla(187, 98%, 16%, 1)"}
//             border={"1px solid hsla(187, 98%, 16%, 1)"}
//             width={"90px"}
//             height={"34px"}
//             borderRadius={"12px"}
//             onclick={() => navigate(-1)}
//           />
//           <CustomButton
//             title={"Submit"}
//             txtClr={"#FFFFFF"}
//             background={isSubmitDisabled ? "grey" : "hsla(187, 98%, 16%, 1)"}
//             width={"90px"}
//             height={"34px"}
//             borderRadius={"12px"}
//             onClick={handleSubmit}
//             disabled={isSubmitDisabled}
//           />
//         </div>
//       </div>
//     </>
//   );
// };

// const mapStateToProps = (state, props) => {
//   return {
//     offer: state?.offer?.offer,
//     categories: state?.category?.categories,
//     products: state?.product?.products,
//   };
// };

// export default connect(mapStateToProps, null)(EditOffer);


